import { render, staticRenderFns } from "./vueMenu.vue?vue&type=template&id=85389908"
import script from "./vueMenu.vue?vue&type=script&lang=js"
export * from "./vueMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports